import React from "react";
import {Helmet} from "react-helmet";
import HY from "../../assets/images/haoyi/haoyi.png";
import HYPoster from "../../assets/images/haoyi/haoyi-poster.jpg";

export default function BatAndHorse() {
    return (
        <div>
            <Helmet>
                <title>AI翻译小程序 AI Translator Mini-Program</title>
            </Helmet>
            <h6 className="App-essay-title">AI翻译小程序</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二四 十二月</b>
                <br/><br/>
                发布一款小得不能再小的AI翻译工具，是我亲手从头到尾写完的产品：好译。
                <br/><br/>
                <ol>
                    <li>好译支持中英翻译。支持长文本，图片和语音</li>
                    <li>好译为你保存所有的翻译记录，提供比快餐式翻译更适合文字的界面</li>
                    <li>在速度和稳定性上，好译不可能和大厂产品较量。带宽和AI模型的成本对于一个国家都过于高昂，对我更是。</li>
                </ol>
                把AI生成的文字并列在楚辞、王勃、李白、杜甫、杜牧、苏轼、黄庭坚…等等桂冠诗人的文章旁边，是破坏氛围的。所以小程序的“辞章”里，我选了几首许渊冲先生的译文，他们都配得上。
                <br/><br/>
                下面张卡片不是AI生成的，是无名氏我做的。这张卡片送给和我一样经受建筑师训练的朋友，和不断制造新事物的人。
                <br/><br/>
                长按下图可以体验小程序，请做好目睹漏洞百出的准备，也请把这款产品当做一个认真的玩笑。大家可以邮件反馈我，地址在我blog最后一栏，因为微信无法迫使人认真沟通。感谢体验。
                <br/><br/>
                <img src={HYPoster} alt="" width={"100%"}/>
                <br/><br/>
                <img src={HY} alt="" width={"100%"}/>

            </p>

            <br/>

            <h6 className="App-essay-title">AI Translator Mini-Program</h6>
            <p className="App-essay-article">
                <br/>
                <b>Dec 2024</b>
                <br/><br/>

            </p>
        </div>)
}
